import { useTranslation } from 'react-i18next';

export default function PaymentInfo() {
  const { t } = useTranslation();

  return (
    <div className="space-y-8">
      <div>
        <h3 className="text-lg font-semibold mb-4 text-gray-800">
          {t('payment.title')}
        </h3>

        <div className="bg-gray-50 p-6 rounded-xl space-y-4">
          <p className="text-gray-600 font-light leading-relaxed">
            {t('payment.title')}
          </p>

          <div className="pt-4 border-t border-gray-200">
            <p className="text-sm font-light text-gray-600 mb-3">
              {t('payment.text')}
            </p>
            <div className="space-y-2 font-light text-sm text-gray-700">
              <p>
                <span className="text-gray-600">{t('payment.iban')}:</span>{' '}
                <span className="font-mono">CH38 0024 3243 6805 1840 L</span>
              </p>
              <p>
                <span className="text-gray-600">{t('payment.bic')}:</span>{' '}
                <span className="font-mono">UBSWCHZH80A</span>
              </p>
              <p>
                <span className="text-gray-600">{t('payment.beneficiary')}:</span>{' '}
                Les Amis de SHALOM, 1024 ECUBLENS VD
              </p>
            </div>
          </div>

          {/* QR Code Section */}
          <div className="pt-6 border-t border-gray-200 flex flex-col items-center">
            <p className="text-sm font-light text-gray-600 mb-3">
              {t('payment.qr')}
            </p>
            <div className="bg-white p-3 rounded-xl shadow-sm">
              <img
                src="/qr-code.png"
                alt="QR Code SHALOM"
                className="w-32 h-32 object-contain"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="pt-2 text-sm font-light text-gray-600 text-center">
        <p>{t('payment.contact')}</p>
      </div>
    </div>
  );
}